import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  style: {
    "flex": "1",
    "position": "relative"
  }
};
const _hoisted_2 = {
  style: {
    "position": "absolute",
    "top": "0",
    "left": "0",
    "right": "0",
    "bottom": "0"
  }
};
import { TABLE_PAGE_URL } from '../../api/code-gen';
import { XTable } from '@/components/index';
import { ScaleToOriginal, Search, Refresh } from '@element-plus/icons-vue';
import { toast } from '@/utils/message';

import { ref, reactive } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'TableSelect',
  emits: ['select'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const tableRef = ref();
    const queryFormRef = ref();
    const emits = __emit;
    const query = reactive({
      model: {
        tableName: '',
        tableComment: ''
      }
    });
    const table = reactive({
      data: [],
      url: TABLE_PAGE_URL
    });
    function handleGenerate(tableName) {
      emits('select', tableName);
    }
    function handleQuery() {
      tableRef.value?.load(query.model);
    }
    function handleReset() {
      queryFormRef.value?.resetFields();
    }
    function getSelectedTableName() {
      const selection = tableRef.value?.getSelectRows();
      if (!selection || selection.length === 0) {
        toast.warn('请选择需要生成代码的表');
        return;
      }
      if (selection.length > 1) {
        toast.warn('只能选择一张表');
        return;
      }
      return selection[0].tableName;
    }
    __expose({
      getSelectedTableName
    });
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_link = _resolveComponent("el-link");
      const _component_XAppLayout = _resolveComponent("XAppLayout");
      return _openBlock(), _createBlock(_component_XAppLayout, null, {
        default: _withCtx(() => [_createVNode(_component_el_form, {
          ref_key: "queryFormRef",
          ref: queryFormRef,
          model: _unref(query).model,
          inline: true
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "表名称",
            prop: "tableName"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(query).model.tableName,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(query).model.tableName = $event),
              placeholder: "表名称",
              maxlength: "50",
              clearable: ""
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "表描述",
            prop: "tableComment"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(query).model.tableComment,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(query).model.tableComment = $event),
              placeholder: "表描述",
              maxlength: "50",
              clearable: ""
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              type: "primary",
              icon: _unref(Search),
              onClick: handleQuery
            }, {
              default: _withCtx(() => _cache[2] || (_cache[2] = [_createTextVNode("查询")])),
              _: 1
            }, 8, ["icon"]), _createVNode(_component_el_button, {
              icon: _unref(Refresh),
              onClick: handleReset
            }, {
              default: _withCtx(() => _cache[3] || (_cache[3] = [_createTextVNode("重置")])),
              _: 1
            }, 8, ["icon"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"]), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_unref(XTable), {
          ref_key: "tableRef",
          ref: tableRef,
          url: _unref(table).url,
          "show-index": "",
          selectable: "",
          "el-table-props": {
            border: true
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            label: "表名称",
            prop: "tableName",
            sortable: "",
            asc: ""
          }), _createVNode(_component_el_table_column, {
            label: "表描述",
            prop: "tableComment",
            sortable: ""
          }), _createVNode(_component_el_table_column, {
            label: "创建时间",
            prop: "createTime",
            sortable: ""
          }), _createVNode(_component_el_table_column, {
            label: "操作",
            width: "200",
            align: "center"
          }, {
            default: _withCtx(({
              row
            }) => [_createVNode(_component_el_link, {
              underline: false,
              icon: _unref(ScaleToOriginal),
              type: "primary",
              onClick: $event => handleGenerate(row.tableName)
            }, {
              default: _withCtx(() => _cache[4] || (_cache[4] = [_createElementVNode("span", {
                style: {
                  "padding-left": "4px"
                }
              }, "生成代码", -1)])),
              _: 2
            }, 1032, ["icon", "onClick"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["url"])])])]),
        _: 1
      });
    };
  }
});